import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { TtButton } from '@23/ui-react'

import './AudienceFoyerOptionsComponent.scss'

/**
 * AudienceFoyerOptionsComponent
 */
const AudienceFoyerOptionsComponent = ({ name, fromLink, onOptionClick }) => {
  const onImNotClick = useCallback(() => {
    /**
     * There can be instances where we don't have access to localStorage on
     *  window. Wrapping in a exception handler - better safe than sorry.
     */
    try {
      window.localStorage.clear()
    } finally {
      window.location.href = `/logout?return_url=${encodeURIComponent(
        fromLink
      )}`
    }
  }, [fromLink])

  return (
    <div className="audience-foyer-options-container">
      <TtButton size="small" color="info" onClick={onOptionClick('audience')}>
        <FormattedMessage defaultMessage="Join webinar" />
      </TtButton>
      {!!name && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button type="button" className="im-not" onClick={onImNotClick}>
          <FormattedMessage defaultMessage="I'm not {name}" values={{ name }} />
        </button>
      )}
    </div>
  )
}

AudienceFoyerOptionsComponent.propTypes = {
  name: PropTypes.string.isRequired,
  fromLink: PropTypes.string.isRequired,
  onOptionClick: PropTypes.func.isRequired,
}

export default AudienceFoyerOptionsComponent
